import React from 'react'
import "../index.css"
import { Link } from 'react-router-dom'
export default function Navbar() {
  return (
    <div className='navbar'>
        <Link to="/">
        <div>
            <h3>Home</h3>
        </div>
        </Link>
        <Link to="/note">

        <div>
           <h3>Note</h3>
        </div>
        </Link>
        <Link to="/bookmark">
        <div>
           <h3>Bookmark</h3>
        </div>
        </Link>
    </div>
  )
}